<template>
  <v-layout>
    <v-flex xs12 sm12 md12 lg10 offset-lg1>
      <v-container fluid>
        <v-card>
          <v-card-title>
            <h3 class="headline pa-1">{{ $t('results.TITLE') }}</h3>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              :label="$t('forms.SEARCH')"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            v-if="this.$auth.check('EXPERT')"
            v-bind:headers="headersExpert"
            v-bind:search="search"
            v-bind:pagination.sync="pagination"
            :items="orderedQuestionnairesList"
            :rows-per-page-text="$t('results.table.ROWSPERPAGE')"
            :rows-per-page-items="rowsPageItems"
            class="elevation-1">
            <template slot="items" slot-scope="props" >
              <tr style="cursor: pointer;" v-show="props.item.isCompleted" @click="props.expanded = !props.expanded" v-bind:class="{'grey lighten-2': !props.item.control}">
                <td>{{props.item.creationDate | formatDate}}</td>
                <td>{{props.item.teacherName}}</td>
                <td>{{props.item.schoolName}}</td>
                <td>{{props.item.degree ? degrees[props.item.degree] : '-'}}</td>
                <td>{{props.item.group ? groups[props.item.group] : '-'}}</td>
                <td>{{props.item.subject ? props.item.subject : '-'}}</td>
                <td width="5%">
                  <v-icon v-if="props.item.control">check</v-icon>
                  <v-icon v-else>remove</v-icon>
                </td>
                <td width="5%">
                  <v-tooltip top>
                    <v-btn icon v-on:click="$router.push({ name: 'Result', params: {questionnaireId: props.item.id} })" slot="activator">
                      <v-icon>forward</v-icon>
                    </v-btn>
                    <span>{{ $t('results.tooltips.LOOK') }}</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template slot="expand" slot-scope="props">
              <v-card flat>
                <v-card-title>{{ $t('questionnaires.labels.DESCRIPTION') }}: </v-card-title>
                <v-card-text>{{ props.item.activityDescription }}</v-card-text>
                <v-card-title v-if="props.item.comments">{{ $t('questionnaires.labels.COMMENTS') }}: </v-card-title>
                <v-card-text v-if="props.item.comments">{{ props.item.comments }}</v-card-text>
                <v-card-title v-if="props.item.control">{{ $t('questionnaires.labels.EXPERT') }}:</v-card-title>
                <v-card-text v-if="props.item.control">{{ props.item.expertName }}</v-card-text>
              </v-card>
            </template>
          </v-data-table>
          <v-data-table
            v-if="this.$auth.check('TEACHER')"
            v-bind:headers="headersTeacher"
            v-bind:search="search"
            v-bind:pagination.sync="pagination"
            :rows-per-page-text="$t('results.table.ROWSPERPAGE')"
            :rows-per-page-items="rowsPageItems"
            :items="orderedQuestionnairesList"
            class="elevation-1">
            <template slot="items" slot-scope="props">
              <tr v-show="props.item.isCompleted">
                <td>{{props.item.creationDate | formatDate}}</td>
                <td>{{props.item.degree ? degrees[props.item.degree] : '-'}}</td>
                <td>{{props.item.group ? groups[props.item.group] : '-'}}</td>
                <td>{{props.item.subject ? props.item.subject : '-'}}</td>
                <td>{{props.item.activityDescription}}</td>
                <td>{{props.item.comments}}</td>
                <td>
                  <v-tooltip>
                    <v-btn icon v-on:click="$router.push({ name: 'Result', params: {questionnaireId: props.item.id} })" slot="activator">
                      <v-icon>forward</v-icon>
                    </v-btn>
                    <span>{{ $t('results.tooltips.LOOK') }}</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </v-flex>
    <v-btn fab large bottom left fixed class="warning" v-on:click="$router.push({ name: 'Home' })"><v-icon>arrow_back</v-icon></v-btn>
    <loading v-model="loading" :message="$t('common.LOADING')"></loading>
  </v-layout>
</template>
<script>
  import {PopupResource} from '../../api/popup'
  import {SchoolResource} from '../../api/school'
  import {QuestionnaireResource} from '../../api/questionnaire'
  import {UserResource} from '../../api/user'
  import moment from 'moment'
  import Loading from '@/components/common/Loading'
  import {GROUPS} from '../../api/utils'
  export default {
    name: 'questionnaires',
    components: {
      Loading
    },
    data () {
      const generateDict = function (arr) {
        var res = {}
        arr.forEach(function (item) {
          res[item.value] = item.text
        })
        return res
      }
      return {
        questionnaires: [],
        search: '',
        headersExpert: [
          { text: this.$t('questionnaires.headers.DATE'), value: 'creationDate' },
          { text: this.$t('questionnaires.headers.TEACHER'), align: 'left', value: 'teacherName' },
          { text: this.$t('questionnaires.headers.SCHOOL'), align: 'left', value: 'schoolName' },
          { text: this.$t('questionnaires.new.DEGREE'), align: 'left', value: 'degree' },
          { text: this.$t('questionnaires.headers.GROUP'), align: 'left', value: 'group' },
          { text: this.$t('questionnaires.headers.SUBJECT'), align: 'left', value: 'subject' },
          { text: this.$t('questionnaires.headers.CONTRAST'), align: 'left', value: 'isControl' }
        ],
        headersTeacher: [
          { text: this.$t('questionnaires.headers.DATE'), value: 'creationDate' },
          { text: this.$t('questionnaires.new.DEGREE'), align: 'left', value: 'degree' },
          { text: this.$t('questionnaires.headers.GROUP'), align: 'left', value: 'group' },
          { text: this.$t('questionnaires.headers.SUBJECT'), align: 'left', value: 'subject' },
          { text: this.$t('questionnaires.headers.DESCRIPTION'), align: 'left', value: 'activityDescription' },
          { text: this.$t('questionnaires.headers.COMMENTS'), align: 'left', value: 'comments' }
        ],
        sortOptions: {
          orderField: 'id',
          direction: 'asc'
        },
        pagination: {
          sortBy: 'id',
          descending: true
        },
        popups: [],
        dialogUsing: false,
        loadingUsing: false,
        checkedUsing: false,
        showDialogSchoolTeacher: false,
        newQuestionnaire: {
          schoolId: '',
          teacherId: '',
          groupClass: '',
          activityDescription: '',
          date: '',
          kidsNumber: 0
        },
        schools: [],
        teachers: [],
        teachersLoaded: false,
        loading: false,
        generalLoading: false,
        datemenu: false,
        teachersGroupClass: '',
        rowsPageItems: [10, 20, 30, { text: 'All', value: -1 }],
        degrees: null,
        groups: generateDict(GROUPS)
      }
    },
    created () {
      this.loading = true
      PopupResource().get().then(response => {
        this.popups = response.body
        for (var i in this.popups) {
          switch (this.popups[i].name) {
            case 'USING':
              this.dialogUsing = true
              break
          }
        }
      }, response => {
        console.log(response)
      })
      QuestionnaireResource().get().then(response => {
        var allQuestionnaires = response.body
        console.log('Campos de los cuestionarios recibidos:', allQuestionnaires)
        var completedQuestionnaires = []
        for (var key in allQuestionnaires) {
          if (allQuestionnaires[key].isCompleted) completedQuestionnaires.push(allQuestionnaires[key])
        }
        this.questionnaires = completedQuestionnaires
        console.log(this.questionnaires)
        this.loading = false
      }, response => {
        console.log(response)
        this.loading = false
      })
      console.log(this.$auth.user())
      if (this.$auth.check('TEACHER')) {
        UserResource().get({id: this.$auth.user().id}).then(
          response => {
            var teacher = response.data
            this.teachersGroupClass = teacher.degree + ' ' + this.$t('stage.' + teacher.stage)
            this.newQuestionnaire.groupClass = this.teachersGroupClass
          }
        )
      }
    },
    mounted () {
      SchoolResource().get().then(
        response => {
          this.schools = response.data
        },
        response => {
          console.log('error in schools endpoint')
        }
      )
    },
    watch: {
      'newQuestionnaire.schoolId': function () {
        if (this.newQuestionnaire.schoolId !== '') {
          this.loading = true
          this.teachersLoaded = false
          SchoolResource().getTeachers({id: this.newQuestionnaire.schoolId}).then(
            response => {
              this.teachers = response.data
              this.teachersLoaded = true
              this.loading = false
            },
            response => {
              console.log('error in teachers endpoint')
            }
          )
        }
      },
      'newQuestionnaire.teacherId': function () {
        if (this.newQuestionnaire.teacherId !== '') {
          var teacher = this.findItemById(this.teachers, this.newQuestionnaire.teacherId)
          this.newQuestionnaire.groupClass = teacher.degree + ' ' + this.$t('stage.' + teacher.stage)
        }
      }
    },
    computed: {
      orderedQuestionnairesList: function () {
        return this._.orderBy(this.questionnaires, this.sortOptions.orderField, this.sortOptions.direction)
      },
      schoolSelected: function () {
        return this.newQuestionnaire.schoolId !== '' && this.newQuestionnaire.schoolId !== null
      },
      canSelectTeacher: function () {
        return this.schoolSelected && this.teachersLoaded
      },
      teacherSelected: function () {
        return this.newQuestionnaire.teacherId !== '' && this.newQuestionnaire.teacherId !== null
      },
      requiredInfoIntroduced: function () {
        return this.newQuestionnaire.groupClass !== '' && this.newQuestionnaire.groupClass !== null &&
          this.newQuestionnaire.activityDescription !== '' && this.newQuestionnaire.activityDescription !== null
      },
      disableStartButton: function () {
        return !this.schoolSelected || !this.teacherSelected || !this.requiredInfoIntroduced
      },
      computedDate: function () {
        return this.newQuestionnaire.date | this.formatDate
      },
      canICreateAQuestionnaire: function () {
        if (this.$auth.check('TEACHER')) {
          if (this.questionnaires.length < 1) return false
          for (var key in this.orderedQuestionnairesList) {
            if (!this.orderedQuestionnairesList[key].completed) return false
          }
          return true
        } else {
          return true
        }
      }
    },
    filters: {
      formatDate: function (value) {
        if (value) {
          return moment(String(value)).format('DD/MM/YYYY')
        }
      },
      formatFromUTC: function (value) {
        if (value) {
          var thisdate = new Date(value[0], value[1] - 1, value[2])
          return moment(thisdate).format('DD/MM/YYYY')
          // return value[2] + '/' + value[1] + '/' + value[0]
        }
      }
    },
    methods: {
      closeDialogUsing: function () {
        this.dialogUsing = false
      },
      closeUsing: function () {
        this.loadingUsing = true
        var popupid = this.findItemByName(this.popups, 'USING').id
        PopupResource().remove({id: popupid}).then(response => {
          this.loadingUsing = false
          this.checkedUsing = true
        }, response => {
          this.loadingUsing = false
        })
      },
      selectSchoolAndTeacher: function () {
        this.showDialogSchoolTeacher = true
      },
      closeSelectSchoolAndTeacher: function () {
        this.showDialogSchoolTeacher = false
        this.newQuestionnaire.schoolId = ''
        this.newQuestionnaire.teacherId = ''
        if (!this.$auth.check('TEACHER')) {
          this.newQuestionnaire.groupClass = ''
        }
        this.newQuestionnaire.activityDescription = ''
        this.newQuestionnaire.date = new Date()
        this.newQuestionnaire.kidsNumber = null
        this.teachers = []
        this.loading = false
      },
      findItemByName: function (collection, itemName) {
        return this._.find(collection, function (i) {
          return i.name === itemName
        })
      },
      findItemById: function (collection, id) {
        return this._.find(collection, function (i) {
          return i.id === id
        })
      },
      startQuestionnaire: function () {
        this.generalLoading = true
        var newQuestionnaireId
        var model = {
          groupClass: this.newQuestionnaire.groupClass,
          activityDescription: this.newQuestionnaire.activityDescription,
          kidsNumber: this.newQuestionnaire.kidsNumber,
          creationDate: moment(new Date(this.newQuestionnaire.date)).format('YYYY-MM-DD')
        }
        console.log('date: ' + model.creationDate)
        QuestionnaireResource().createControl({id: this.newQuestionnaire.teacherId}, model).then(response => {
          this.generalLoading = false
          newQuestionnaireId = response.body
          this.$router.push({name: 'Questionnaire', params: {questionnaireId: newQuestionnaireId}})
        }, response => {
          console.log('ERROR')
          this.generalLoading = false
        })
      },
      startQuestionnaireTeacher: function () {
        this.generalLoading = true
        var newQuestionnaireId
        var model = {
          groupClass: this.newQuestionnaire.groupClass,
          activityDescription: this.newQuestionnaire.activityDescription,
          kidsNumber: this.newQuestionnaire.kidsNumber,
          creationDate: moment(new Date(this.newQuestionnaire.date)).format('YYYY-MM-DD')
        }
        QuestionnaireResource().save(model).then(response => {
          this.generalLoading = false
          newQuestionnaireId = response.body
          this.$router.push({name: 'Questionnaire', params: {questionnaireId: newQuestionnaireId}})
        }, response => {
          this.generalLoading = false
          alert(response.body)
        })
      },
      startControlOfExisting: function (idQuestionnaire) {
        this.generalLoading = true
        var newQuestionnaireId
        QuestionnaireResource().createControlOfExisting({id: idQuestionnaire}, '').then(response => {
          this.generalLoading = false
          newQuestionnaireId = response.body
          this.$router.push({name: 'Questionnaire', params: {questionnaireId: newQuestionnaireId}})
        }, response => {
          console.log('error:' + response)
          this.generalLoading = false
        })
      },
      getGroupClass: function () {
        UserResource().get({id: this.$auth.user().id}).then(
          response => {
            var teacher = response.data
            return teacher.degree + ' ' + this.$t('stage.' + teacher.stage)
          }
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/results/Results.vue